export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN;
